import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-schedule1',
  templateUrl: './schedule1.component.html',
  styleUrls: ['./schedule1.component.scss']
})
export class Schedule1Component implements OnInit {

  @Input() scheduleWrapper1Type:string;

  constructor() { }

  ngOnInit(): void {
  }

}
